<div class="tabheadingsoverflow">
  <div class="row">
    <div class="col-lg-9">
      <h3 class="bluelabel margin-bottom-15">Documents</h3>
      <h4 class="bov-file-uploads"><span class="cound">{{rowCount}}</span> File Uploaded</h4>
    </div>
    <div class="col-lg-3">
      <button type="button" class="btn margin-bottom-15 btn-lg btn-addgreen pull-right"
              aria-controls="dropdown-basic" (click)="OpenAddFileSlider(UploadFileNew, 'portfolioUpload')" tooltip="Upload Files" triggers="mouseenter:mouseleave"
              placement="left" triggers="mouseenter:mouseleave">
        Upload
      </button>
    </div>
  </div>
 
  <div class="table-responsive">
    <table class="table basictable" datatable [dtOptions]="dtOptions">
      <thead>
        <tr>
          <th data-orderable="false">Action</th>
          <th>Document Title</th>
          <th>Category</th>
          <th>Uploaded By</th>
          <th>Date</th>

        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let doc of propertyDocuments; let i = index;">
          <td>

            <div class="whitespacenowrap">
              <a class="blueone" tooltip="Edit File" href="javascript:void(0);" (click)="openEditModal(EditFile,'',doc.Id,doc.CategoryId)" style="font-size:15px">
                <i class="icofont icofont-ui-edit" aria-hidden="true"></i>
              </a>
              <a *ngIf="doc.Url.includes('.pdf')" href="javascript:void(0);" (click)="previews(preview,'pdf-view-modal', doc)" tooltip="Preview" placement="top">
                <i aria-hidden="true" class="fa fa-eye"></i>
              </a>
              <a *ngIf="doc.Url != null && doc.Url.length > 0" class="view" href={{doc.Url}} download target="_blank" placement="top" tooltip="Download" ng-reflect-tooltip="Download"
                 ng-reflect-placement="top" triggers="hover">
                <i aria-hidden="true" class="icofont icofont-download-alt"></i>
              </a>
              <a href="javascript:void(0);" (click)="removeModel(template,'deletemodal', doc)" class="remove" tooltip="Remove" placement="top">
                <i class="icofont icofont-close" aria-hidden="true"></i>
              </a>
            </div>
          </td>
          <td>
            <p>{{doc.Name}}</p>
          </td>
          <td>
            <p>{{doc.Category}}</p>
          </td>
          <td>
            <p>{{doc.UploadedBy}}</p>
          </td>
          <td>
            <p>{{doc.UploadedDate | date:"MM/dd/yyyy"}}</p>
          </td>

        </tr>
      </tbody>
      <!--<tfoot *ngIf=" propertyDocuments == undefined || propertyDocuments == null || propertyDocuments?.length == 0">
          <tr >
              <td colspan="8" class="odd no-data-available">
                  <div class="nodata">
                      <i class="fa fa-exclamation-triangle icon"></i>
                      <p>No Data Available</p>
                  </div>
              </td>
          </tr>
      </tfoot>-->
    </table>
  </div>

  <!--<div>
      <div>
          <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div class="floatinghead clearfix bov-file-upload">
                      <file-upload [uploadType]="fileUploadType" [messageDisplayes]="1" (selectedFilesListEmitter)=selectedFilesListEmitter($event) [maxFiles]="5" [showList]="false" [extensionType]="fileExtensionType" [clearFilescounter]="clearFiles"></file-upload>
                  </div>
                  <div class="table-responsive">
                      <table class="table basictable fixedlayouttable" *ngIf="filesCollection.length > 0">
                          <thead>
                              <tr>
                                  <th class="minwidth40">File</th>
                                  <th class="minwidth40">Category</th>
                                  <th class="minwidth20">Action</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr *ngFor="let file of filesCollection;let i = index" [attr.data-index]="i">
                                  <td>{{file.name}}</td>
                                  <td>
                                      <label class="select">
                                          <select class="form-control " [(ngModel)]="file.category">
                                              <option value="0">--Select--</option>
                                              <option *ngFor="let cat of docCategories" [ngValue]="cat.id">{{cat.description}}</option>
                                          </select>
                                          <i></i>
                                      </label>
                                  </td>
                                  <td>
                                      <a class="remove" href="javascript:void(0);" (click)="removeDoc(i,$event)" tooltip="Remove"><i aria-hidden="true" class="icofont icofont-close"></i></a>
                                  </td>

                              </tr>
                          </tbody>
                      </table>
                  </div>
                  <br />
                  <div class="text-right" *ngIf="filesCollection.length > 0">
                      <button type="button" class="btn btn-default  btn-lg" (click)="onFilesClear();">Clear All</button>
                      <button class="btn btn-success  btn-lg" (click)="uploadFiles();">Upload</button>
                  </div>
              </div>
          </div>
      </div>
  </div>-->


  <h3 class="bluelabel collapse-hd d-flex" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample" style="display:flex !important;position: relative;
    top: -20px;margin-bottom:-20px;">
    <span class="mr-auto">Checklist</span>
    <i class="fa fa-angle-right" aria-hidden="true"></i>
  </h3>
  <div class="collapse in checklist-collapse" id="collapseExample">
    <div class="table-responsive">
      <table class="table basictable">
        <thead>
          <tr>
            <th>Document Type   </th>
            <th># of Attachments</th>
            <th>Note</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let doc of checkList; let i = index;">
            <td>
              <p>{{doc.Description}}</p>
            </td>
            <td>
              {{doc.Count}}
            </td>
            <td>
              <!--<p *ngIf="!IsAdmin">
                  {{doc.Notes ? doc.Notes : "-"}}
              </p>
              <a *ngIf="IsAdmin" (click)="onAddOrEditNotes(note,'panlestyle',doc)">
                  <i _ngcontent-iig-c18="" aria-hidden="true" class="icon-inquiry"></i>
              </a>-->
              <a class="bluetwo" [ngClass]="{'newnote': doc.UnReadNoteCount!=0}" href="javascript:void(0);" (click)="openModalForNotes(notestemplate,'panlestyle sharednotesmodal',doc)" tooltip="Notes"><i aria-hidden="true" class="icon-inquiry"></i></a>
               </td>
              </tr>
        </tbody>
        <tfoot>
          <!--<tr *ngIf="docCategories?.length == 0">
              <td colspan="8" class="odd no-data-available">
                  <div class="nodata">
                      <i class="fa fa-exclamation-triangle icon"></i>
                      <p>No Data Available</p>
                  </div>
              </td>
          </tr>-->
        </tfoot>
      </table>
    </div>
  </div>


</div>

<ng-template #template>

    <div class="modal-header">
        <h4 class="modal-title pull-left">Delete Document?</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="removeModalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body padding30">

        <div class="form-group">
            <h6 class="displayvalue">Are you sure to delete?</h6>
        </div>
        <div class="text-right">
            <button class="btn btn-lg btn-default" (click)="removeModalRef.hide()">Cancel</button>
            <button class="btn btn-lg btn-danger" (click)="deleteBOVDoc(UpdateItem);removeModalRef.hide();">Delete</button>
        </div>
    </div>
</ng-template>

<ng-template #EditFile>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Edit File</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefEdit.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <label class="form-label">File Category</label>
      <label class="select">
        <select class="form-control" [(ngModel)]="editfileCategoryId">
          <option *ngFor="let cat of docCategories" [ngValue]="cat.id">{{cat.description}}</option>
        </select>
        <i></i>
      </label>
    </div>

    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefEdit.hide()">Cancel</button>
      <button class="btn btn-success btn-lg" (click)="UpdateDocCategory();">Save</button>
    </div>
  </div>

</ng-template>

<ng-template #note>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Note</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="onClose()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="form-group">
            <label class="form-label">
                Notes
            </label>
            <textarea #textarea="ngModel" class="form-control property-description" maxlength="500" [(ngModel)]="Note" rows="3"></textarea>
        </div>
        <div class="form-group">
            <div class="text-right">
                <button type="button" (click)="onClose()" class="btn btn-default btn-lg">Cancel</button>
                <button type="button" (click)="saveNote()" class="btn btn-success btn-lg">Save</button>
            </div>

        </div>
    </div>

</ng-template>

<ng-template #preview>
  <div class="modal-header">
    <!--<h4 class="modal-title pull-left">{{docPreview.Name}}</h4>-->
    <button type="button" class="close pull-right" aria-label="Close" (click)="documentPreview.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <ngx-extended-pdf-viewer [src]="docPreview.Url" [showBookmarkButton]="false" useBrowserLocale="true" height="80vh"></ngx-extended-pdf-viewer>

  <!--<pdf-viewer [external-link-target]="'blank'" [show-all]="true" [show-borders]="true" [original-size]="true" [src]="docPreview.Url"
              [render-text]="true"
              style="display: block;"></pdf-viewer>-->
</ng-template>

<ng-template #notestemplate>
    <app-shared-add-notes [isEditable]="IsAdmin || IsBroker || IsSeller" (close)="closeModal" [modalRef]="modalNoteRef" [notesInputsModel]="NotesInput"></app-shared-add-notes>
</ng-template>
<ng-template #UploadConfirmation>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">Please refresh this page once the file uploads are complete.</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-success" (click)="uploadFiles();">Ok</button>
    </div>
  </div>
</ng-template>
<ng-template #UploadFileNew>
  <div class="modal-body modal-scroll-body padding30">
    <div class="offredetailspage section-margin">
      <div class="container">
        <div class="row">
          <button type="button" class="close pull-right file-pop-up-close" aria-label="Close" (click)="CloseFile();">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <h3 class="file-bluelabel margin-bottom-15">Upload</h3>
            <br />
            <div class="floatinghead clearfix bov-file-upload">
              <file-upload [uploadType]="fileUploadType" [messageDisplayes]="1" (selectedFilesListEmitter)=selectedFilesListEmitter($event) [maxFiles]="5" [showList]="false" [fileDocExt]="'pdf,xlsx,doc,docx,xls,txt,dwg'" [extensionType]="fileExtensionType" [clearFilescounter]="clearFiles" [fileTypes]="fileTypes"></file-upload>
            </div>
            <div class="table-responsive">
              <table class="table basictable fixedlayouttable" *ngIf="filesCollection.length > 0">
                <thead>
                  <tr>
                    <th class="minwidth40">File</th>
                    <th class="minwidth40">Category</th>
                    <th class="minwidth20">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let file of filesCollection;let i = index" [attr.data-index]="i">
                    <td><p>{{file.name}}</p></td>
                    <td>
                      <label class="select">
                        <select class="form-control " [(ngModel)]="file.category">
                          <option value="0">--Select--</option>
                          <option *ngFor="let cat of docCategories" [ngValue]="cat.id">{{cat.description}}</option>
                        </select>
                        <i></i>
                      </label>
                    </td>
                    <td>
                      <a class="remove" href="javascript:void(0);" (click)="removeDoc(i,$event)" tooltip="Remove"><i aria-hidden="true" class="icofont icofont-close"></i></a>
                    </td>

                  </tr>
                </tbody>
              </table>
            </div>
            <br />
            <div class="text-right" *ngIf="filesCollection.length > 0">
              <button type="button" class="btn btn-default  btn-lg" (click)="onFilesClear();">Clear All</button>
              <button class="btn btn-success  btn-lg" (click)="uploadFiles();">Upload</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
